import DefaultModal from 'components/common/DefaultModal';
import React from 'react';
import { IAppointmentState } from 'types/appointments';
import { GeneralFunction } from 'types/common';

import NotaryTable from './NotaryTable';

const NotaryTableModal: React.FC<{
  selectedAppointment?: IAppointmentState;
  closeModal: GeneralFunction;
  visible?: boolean;
  refetchTransactionData?: GeneralFunction;
}> = ({ selectedAppointment, closeModal, visible, refetchTransactionData }) => (
  <DefaultModal
    props={{
      width: 850,
      style: { maxWidth: '100%', padding: 0 },
      bodyStyle: { padding: '16px 24px' },
      title: 'Add Notary',
      visible,
      destroyOnClose: true,
      onCancel: closeModal,
      maskClosable: false,
    }}>
    <NotaryTable selectedAppointment={selectedAppointment} refetchTransactionData={refetchTransactionData} />
  </DefaultModal>
);

export default React.memo(NotaryTableModal);
